export const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoiZGFpc3kxMjMyMSIsImEiOiJjbGhhejhjNW8wbWduM2hvaThvOTgzamdpIn0.sLKvL0-cxWSUp_8awXxiJg";

// Mapbox Raster Tiles API (v4) tileset endpoint.
export const MAPBOX_SATELLITE_TILE_URL = `https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.jpg90?access_token=${MAPBOX_ACCESS_TOKEN}`;
